<template>
  <div class="container__info-content">
    <div class="container__info-content--header">
      <img
        src="../../public/img/icons/logo-top.svg"
        alt="Logo Hermes"
        class="header__img"
      />
      <h1 class="header__title">
        Recepção Virtual
      </h1>
    </div>
    <div class="container__info-content--footer">
      <div class="footer__line" />
      <div style="height: 70%">
        <p>
          Seja bem vindo a recepção virtual Hermes, para prosseguir você só
          precisa selecionar a empresa a qual tem algo a tratar
        </p>
        <div class="footer__button">
          <a>Selecione</a>
        </div>
      </div>
      <span style="margin-bottom: 15px; width: 100%; display: flex; justify-content: start;">
        <BackButton variant="link"/>
      </span>
    </div>

  </div>
</template>

<script>
import BackButton from './BackButton.vue';
export default {
  components: {
    BackButton,
  },
  data() {
    return {};
  },
  methods: {},
};

</script>


<style scoped>
.container__info-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 35%;
  min-width: 35%;
  max-width: 35%;
  height: 100%;
  /* max-width: 600px; */
  /* padding: 10px; */
}

.container__info-content--header {
  background-color: #3c3341;
  height: 65%;
  width: 100% !important;
  position: relative;
}

.header__title {
  position: absolute;
  top: 20%;
  z-index: 10000;
  left: 18%;
  font-size: 6.8vw;
}

.header__img {
  width: 12%;
  height: 12%;
  position: absolute;
  left: 20%;
  top: 12%;
  /* object-fit: cover; */
}

.container__info-content--footer {
  height: 50%;
  width: 65%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;

  p {
    color: #838383;
    text-align: justify;
    width: 80%;
    font-size: 1.05vw;
    font-weight: 500;
    /* font-size: 1.3rem; */
  }
}

.footer__button {
  width: 100%;
  display: flex;
  justify-content: end;
  color: #de3012;

  a {
    color: #de3012;
    margin: 10px 0px;
        font-size: 1.05vw;

    /* font-size: 100%; */
  }
}

.footer__line {
  border-bottom: 2px solid #de3012;
  width: 40%;
  height: 20px;
  display: flex;
  justify-content: start;
  align-items: start;
  margin: 10px 0px;
}
</style>